// Canonical category aggregates are not available until the server-side M2-D
// read exists. Keep this hook honest: diagnostic transaction rows cannot be
// presented as a financial ranking.
import { useQuery } from '@tanstack/react-query';

export interface UseSpendByCategoryParams {
  accountId?: string | null;
  dateFrom?: string;
  dateTo?: string;
  enabled?: boolean;
}

export type CanonicalAggregateUnavailable = {
  kind: 'unavailable';
  reason: 'canonical_aggregate_unavailable';
  buckets: readonly [];
  currency: null;
};

const unavailable: CanonicalAggregateUnavailable = {
  kind: 'unavailable',
  reason: 'canonical_aggregate_unavailable',
  buckets: [],
  currency: null,
};

export function useSpendByCategory(params: UseSpendByCategoryParams = {}) {
  const { accountId, dateFrom, dateTo, enabled = true } = params;
  return useQuery({
    queryKey: ['spend-by-category', { accountId, dateFrom, dateTo, availability: 'canonical_aggregate_unavailable' }],
    enabled,
    queryFn: async (): Promise<CanonicalAggregateUnavailable> => unavailable,
  });
}

export default useSpendByCategory;
